/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import { CompanyUser, CompanyGroup } from '@/views/companies/interfaces';
import { randomId, findById, mockServerApi, filterByKeys } from '@/common/utils';
import { COMPANY_GROUPS_LIST, COMPANY_USERS_LIST, USERS } from '../data';

export const usersRequests = (msw: typeof rest) => [
  msw.get(mockServerApi('/me'), (req, res, ctx) => {
    const email = window.localStorage.getItem('email');
    const user = USERS.find((companyUser) => companyUser.email === email);

    return res(
      ctx.status(200),
      ctx.json(user),
    );
  }),

  msw.post(mockServerApi('/users'), (req: { body: CompanyUser }, res, ctx) => {
    const newUserEmail = req.body.email;

    if (filterByKeys([...COMPANY_USERS_LIST], ['email'], newUserEmail).length > 0) {
      return res(
        ctx.status(422),
        ctx.json({
          message: 'Email already exists',
          field: 'email',
        }),
      );
    }

    const licenseIds = req.body.licenses;
    const groupIds = req.body.groups;

    const response = {
      ...COMPANY_USERS_LIST[0],
      id: randomId(),
      firstName: req.body.firstName,
      lastName: req.body.lastName,
      email: req.body.email,
    };

    if (licenseIds) {
      response.licenses = (licenseIds.length === 0) ? [] : [...COMPANY_USERS_LIST[0].licenses];
    }

    if (groupIds) {
      response.groups = (groupIds.length === 0) ? [] : req.body.groups.map((groupId) => {
        const group = findById(COMPANY_GROUPS_LIST, groupId) as CompanyGroup;
        return { id: groupId, name: group.name };
      });
    }

    COMPANY_USERS_LIST.push(response);

    return res(
      ctx.status(201),
      ctx.json(response),
    );
  }),

  msw.patch(mockServerApi('/users/:id'), (req: { body: CompanyUser }, res, ctx) => {
    const licenseIds = req.body.licenses;
    const groupIds = req.body.groups;

    const response = { ...req.body };

    if (licenseIds) {
      response.licenses = licenseIds.length === 0 ? [] : [
        ...COMPANY_USERS_LIST[0].licenses, // Only works for active and inactive status - Disabled doesn't matter
      ];
    }

    if (groupIds) {
      response.groups = groupIds.length === 0 ? [] : groupIds.map((groupId) => {
        const group = findById(COMPANY_GROUPS_LIST, groupId) as CompanyGroup;
        return { id: groupId, name: group.name };
      });
    }

    return res(
      ctx.status(200),
      ctx.json(response),
    );
  }),

  msw.delete(mockServerApi('/users/:id'), (req, res, ctx) => {
    const { id } = req.params;

    const index = USERS.findIndex((n) => n.id === id.toString());

    USERS[index].deletedAt = Date.now();

    return res(
      ctx.status(204),
    );
  }),

  msw.get(mockServerApi('/users'), (req, res, ctx) => {
    const q = req.url.searchParams.get('q');
    const deleted = req.url.searchParams.get('deleted');

    let response = USERS.filter((n) => !n.deletedAt);

    if (q === 'email:ends:@craftsmanplus.com') {
      response = response.filter((n) => n.email.includes('@craftsmanplus.com'));
    }

    if (deleted === 'only') {
      response = USERS.filter((n) => n.deletedAt);
    }

    return res(
      ctx.status(200),
      ctx.json({
        items: response,
      }),
    );
  }),

  msw.post(mockServerApi('/users/:id/restore'), (req, res, ctx) => {
    const { id } = req.params;
    const index = USERS.findIndex((n) => n.id === id.toString());

    USERS[index].deletedAt = null;

    return res(
      ctx.status(200),
      ctx.json({
        message: 'ok',
      }),
    );
  }),

  msw.post(mockServerApi('/users/:id/reset'), (req, res, ctx) => {
    const { id } = req.params;
    const index = COMPANY_USERS_LIST.findIndex((n) => n.id === id.toString());

    if (index === -1) {
      return res(
        ctx.status(401),
        ctx.json({
          error: 'Error',
          message: 'User not found',
        }),
      );
    }

    return res(ctx.status(204));
  }),
];

export default usersRequests;
